import { api } from 'API';
import { blankInvoice } from 'Context/CannabisContext';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/NewRequest/RefundTypes';
const analyzeInvoiceUrl = '/invoice/analyze-invoice';
const cannabisRefundEntitledUrl = '/LongTermEquipment/IsCannabisRefundEntitled';

export interface IReimbursements {
  id: number;
  name: string;
  priority: number;
  iconUrlPath: string;
  internalLink: string;
  externalLink: string;
  reqTypeId: string;
  reqSubTypeId: string;
}

export interface IAnalyzeInvoice {
  invoiceDate: Date;
  invoiceId: string;
  invoiceTotal: number;
}

export const getReimbursements = async () => {
  const res = await api.get<IReimbursements[]>(addImposterToUrl(baseUrl, true));
  if (res) return res.data;
};

export const isCannabisRefundEntitled = async () => {
  const res = await api.get<boolean>(
    addImposterToUrl(cannabisRefundEntitledUrl, true)
  );
  if (res) return res.data;
};

export const analyzeInvoice = async (body: any) => {
  const res = await api.post<IAnalyzeInvoice>(
    addImposterToUrl(analyzeInvoiceUrl, true),
    body,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  if (res) return { ...blankInvoice, ...res.data };
  else return blankInvoice;
};
